<template>
  <div class="popupcontainer">

    <!-- Margin Help Card -->
    <b-card v-if="showMarginHelp" no-body v-draggable class="popup app-ctrl">
        <b-card-header style="color: lightgrey; height: 25px; cursor: move" class="pl-2 pb-0 pt-0"
          header-tag="div"
          header-bg-variant="dark"
        >
          <b-row class="mx-0 px-0">
            <b-col class="mx-0 px-0" cols="11">
              {{ $t('Webportal.CX.Margin.HelpPopupTitle')}}
            </b-col>
            <b-col class="mx-0 px-0" cols="1" style="text-align: right">
              <font-awesome-icon
                class="mx-1 clickable"
                :icon="['far', 'times']"
                @click="toggleMarginHelp()"
              />
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body style="max-height: 500px; overflow: auto">

          <h3>{{$t('Webportal.CX.Margin.MarginHelpTitle')}}</h3>
          <p>{{$t('Webportal.CX.Margin.MarginHelpText1')}}</p>

          <table class="table table-bordered">
            <tr>
              <td><MarginKpiStatusIndicator :Accomplished="true" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange" /></td>
              <td>{{ $t('Webportal.CX.Margin.Accomplished') }}</td>
            </tr>
            <tr>
              <td><MarginKpiStatusIndicator :Accomplished="false" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange"/></td>
              <td>{{ $t('Webportal.CX.Margin.Failed') }}</td>
            </tr>
            <tr>
              <td><MarginKpiStatusIndicator :Accomplished="null" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange" /></td>
              <td>{{ $t('Webportal.CX.Margin.NoData') }}</td>
            </tr>
            <tr>
              <td><MarginKpiStatusIndicator :InHealingPeriod="true" :IsCurrentWave="true" :IsHealingDeactivated="false" :Accomplished="false" :HealingStatus="''" :ColorRange="colorRange" :AvailableHealings="1"/></td>
              <td>{{ $t('Webportal.CX.Margin.HealingPossible') }}</td>
            </tr>
            <tr>
              <td><MarginKpiStatusIndicator :Accomplished="false" :HealingStatus="'in_progress'" :InHealingPeriod="false" :IsCurrentWave="true" :ColorRange="colorRange"/></td>
              <td>{{ $t('Webportal.CX.Margin.HealingInProgress') }}</td>
            </tr>
          </table>

          <p>{{$t('Webportal.CX.Margin.MarginHelpText2')}}</p>
          <p>{{$t('Webportal.CX.Margin.MarginHelpText3')}}</p>
          <p>{{$t('Webportal.CX.Margin.MarginHelpText4')}}</p>

          <h5>{{ $t('Webportal.CX.Margin.FAQResultsReleaseHeadline') }}</h5>
          <ul>
            <li>{{ $t('Webportal.CX.Margin.Q1ResultsRelease') }}</li>
            <li>{{ $t('Webportal.CX.Margin.Q2ResultsRelease') }}</li>
            <li>{{ $t('Webportal.CX.Margin.Q3ResultsRelease') }}</li>
            <li>{{ $t('Webportal.CX.Margin.Q4ResultsRelease') }}</li>
          </ul>
        </b-card-body>
    </b-card>

    <!-- Healing Help Card -->
    <b-card v-if="showHealingHelp" no-body v-draggable class="popup app-ctrl">
      <b-card-header style="color: lightgrey; height: 25px; cursor: move" class="pl-2 pb-0 pt-0"
        header-tag="div"
        header-bg-variant="dark"
      >
        <b-row class="mx-0 px-0">
          <b-col class="mx-0 px-0" cols="11">
            {{ $t('Webportal.CX.Margin.MarginHealingHelpPopupTitle') }}
          </b-col>
          <b-col class="mx-0 px-0" cols="1" style="text-align: right">
            <font-awesome-icon
              class="mx-1 clickable"
              :icon="['far', 'times']"
              @click="showHealingHelp=!showHealingHelp"
            />
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body style="max-height: 500px; overflow: auto">
        <margin-healing-popup />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import MarginHealingPopup from "@/components/CX/DashboardCards/MarginHealingPopup.vue"
import MarginKpiStatusIndicator from "./MarginKpiStatusIndicator.vue"

export default {
  name: "MarginHelpPopups",
  components: {
    MarginHealingPopup, MarginKpiStatusIndicator
  },
  props: {
    colorRange: Array
  },
  data: function() {
    return {
      showMarginHelp: false,
      showHealingHelp: false
    }  
  },

  methods:{
    toggleMarginHelp() {
      this.showMarginHelp = !this.showMarginHelp
    },
    toggleHealingHelp() {
      this.showHealingHelp = !this.showHealingHelp
    }
  },
  mounted() {
    EventBus.$on("toggle-margin-help", () => { 
        this.showMarginHelp = !this.showMarginHelp
    });
    EventBus.$on("toggle-healing-help", () => { 
        this.showHealingHelp = !this.showHealingHelp
    });
  }
}
</script>

<style scoped>
.popupcontainer {
  position: absolute;
}
.popup {
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
  border: none;
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 600px;
  min-height: 55px;
}
</style>